import { News, NewsRequest, NewsStatuses } from '../../models';

export namespace NewsAdminActions {
  export class Load {
    public static readonly type = '[NewsAdmin] Load admin news with filters';
  }

  export class SetNewsAdminType {
    static readonly type = '[NewsAdmin] Set news type';
    constructor(public type: number | null) {}
  }

  export class SetSearchText {
    static readonly type = '[NewsAdmin] Set search text';
    constructor(public searchText: string | null) {}
  }

  export class SetSearchTags {
    static readonly type = '[NewsAdmin] Set search tags';
    constructor(public tags: string[]) {}
  }

  export class LoadStatuses {
    public static readonly type = '[NewsAdmin] Load admin news statuses';
  }

  export class SetStatuses {
    static readonly type = '[NewsAdmin] Set admin news statuses';
    constructor(public statuses: NewsStatuses[]) {}
  }

  export class SetStatus {
    static readonly type = '[NewsAdmin] Set admin news status';
    constructor(public status: string | null) {}
  }

  export class LoadTags {
    static readonly type = '[NewsAdmin] Get admin news tags';
  }

  export class CreateNewsAdmin {
    static readonly type = '[NewsAdmin] Create new admin news';
    constructor(
      public news: NewsRequest,
      public file: File
    ) {}
  }

  export class CreateNewsAdminSuccess {
    static readonly type = '[NewsAdmin] Create new admin news success';
  }

  export class UpdateNewsAdmin {
    static readonly type = '[NewsAdmin] Update new admin news';
    constructor(
      public newsId: string,
      public news: NewsRequest,
      public file: File
    ) {}
  }

  export class ResetNewsAdminFilters {
    static readonly type = '[NewsAdmin] Reset admin news filters';
  }

  export class DeleteNewsAdmin {
    static readonly type = '[NewsAdmin] Delete new admin news';
    constructor(public news: News) {}
  }

  export class DeleteNewsPermanentlyAdmin {
    static readonly type = '[NewsAdmin] Delete new permanently admin news';
    constructor(public id: string) {}
  }

  export class DuplicateNewsAdmin {
    static readonly type = '[NewsAdmin] Duplicate News';
    constructor(public id: string) {}
  }
}
